import axios from "axios";
import Cookies from "js-cookie";
import * as types from "../mutation-types";
import { bugsnagClient } from "~/plugins";

// state
export const state = {
  user: null,
  token: (function() {
    return window.localStorage.getItem("token");
  })(),
  userHistory: [],
  subscription: {}
};

// getters
export const getters = {
  user: state => state.user,
  token: state => state.token,
  subscription: state => state.subscription,
  check: state => state.token !== null,
  disclaimer: state => {
    return state.user === null ? false : state.user.disclaimer_accepted;
  },
  userHistory: state => state.userHistory,
  userSubscriptionHasMarketFeature: state => marketFeatureColumnName => {
    return (
      state.subscription &&
      state.subscription.market_features &&
      state.subscription.market_features.some(
        marketFeature =>
          marketFeature.market_feature.column_name === marketFeatureColumnName
      )
    );
  },
  userSubscriptionMaxAggressiveness: state => {
    const subscription = state.subscription;
    if (!subscription) {
      return null;
    }

    if (subscription.name.includes("Herring")) {
      return 15;
    }

    if (subscription.name.includes("Dolphin")) {
      return 50;
    }

    return null;
  },
  userSubscriptionMaxMarkets: state => {
    return state.subscription.max_markets_across_exchanges;
  },
  marketFeatures: () => {
    return {
      ALLOW_BUYS_ABOVE_TRAILING_SELL: "allow_buy_above_trsl",
      BUY_ENTRY_MODULATION: "bem_pct",
      MAX_BUY_PRICE: "max_buy_price",
      MAX_SELL_PRICE_HINT: "max_sell_price_hint",
      MIN_SELL_PRICE: "min_sell_price",
      MIN_TRADE_PROFIT_PERCENTAGE: "min_trade_profit_pct",
      SURPLUS_MIN_SELL_PRICE: "surplus_min_sell_price",
      SURPLUS_SELLING: "do_surplus_selling",
      TRACK_OPTIMISED_MIN_TRADE_PROFIT: "track_mtp_pct",
      TRADE_AGGRESSIVENESS: "aggressiveness_pct",
      TRAILING_BUY: "do_trsl_buy",
      TRAILING_SELL: "do_trailing_stop_loss",
      HODL_AMOUNT: "hodl_amount"
    };
  }
};

// mutations
export const mutations = {
  [types.SAVE_TOKEN](state, { token }) {
    state.token = token;
    window.localStorage.setItem("token", token);
  },
  [types.FETCH_USER_SUCCESS](state, { user }) {
    state.user = user;
  },
  [types.FETCH_USER_FAILURE](state) {
    state.token = null;
    window.localStorage.removeItem("token");
    Cookies.remove("token");
  },
  [types.LOGOUT](state) {
    state.user = null;
    state.token = null;

    window.localStorage.removeItem("token");
    Cookies.remove("token");
  },
  [types.UPDATE_USER](state, { user }) {
    state.user = user;
  },
  [types.USER_HISTORY_SUCCESS](state, { history }) {
    state.userHistory = history;
  },
  [types.USER_HISTORY_FAILURE](state) {
    state.userHistory = [];
  },
  [types.FETCH_USER_SUBSCRIPTION](state, { subscription }) {
    state.subscription = subscription;
  }
};

// actions
export const actions = {
  saveToken({ commit }, payload) {
    commit(types.SAVE_TOKEN, payload);
  },

  async fetchSubscription({ commit }) {
    const { data } = await axios.get("/api/v1/subscriptions/current");
    commit(types.FETCH_USER_SUBSCRIPTION, { subscription: data });
  },

  async fetchUser({ commit, dispatch }) {
    try {
      const { data } = await axios.get("/api/v1/user");

      commit(types.FETCH_USER_SUCCESS, { user: data });

      dispatch("fetchSubscription");

      // Attach to the client object
      bugsnagClient.user = {
        id: data.id,
        name: data.name,
        email: data.email
      };

      // Update intercom data
      window.Intercom("update", {
        email: data.email,
        name: data.name,
        user_id: data.id
      });
    } catch (e) {
      commit(types.FETCH_USER_FAILURE);
    }
  },

  async refreshUserHistory({ commit }) {
    try {
      await axios.get("/api/v1/subscriptions/history").then(res => {
        commit(types.USER_HISTORY_SUCCESS, { history: res.data });
      });
    } catch (e) {
      commit(types.USER_HISTORY_FAILURE);
    }
  },

  updateUser({ commit }, payload) {
    commit(types.UPDATE_USER, { user: payload });
  },

  async logout({ commit }) {
    commit(types.LOGOUT);

    window.Intercom("shutdown");

    // hard refresh instead
    // window.Intercom('boot', {app_id: 'akd7go7w'})
  }
};



// WEBPACK FOOTER //
// ./resources/js/store/modules/auth.js